import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { Result, Spin } from 'antd';
import moment from "moment";
import { Util } from "common/util";
import { getPayrollForBank } from "services/payroll_report";
import withDataTable from "../../withDataTable";

const pathName = "/reports/payroll/payroll_for_bank";
const columns = [
  {
    title: <div>No&deg;</div>,
    dataIndex: "no",
    key: "no",
    width: 100,
    render: (no, record, index) => index + 1
  },
  {
    title: "Name",
    dataIndex: "employeeName",
    key: "employeeName"
  },
  {
    title: "EMP#.",
    dataIndex: "employeeCode",
    key: "employeeCode",
    render: employeeCode => employeeCode
  },
  {
    title: "Last Working Day",
    dataIndex: "lastWorkingDay",
    key: "lastWorkingDay",
    render: lastWorkingDay => lastWorkingDay ? moment(lastWorkingDay).format("MMM DD, YYYY") : ""
  },
  {
    title: "Account Number",
    dataIndex: "bankAccNumber",
    key: "bankAccNumber"
  },
  {
    title: "Salary Amount",
    dataIndex: "salaryAmount",
    key: "salaryAmount",
    align: "right",
    render: salaryAmount => Util.getInstance().formatCurrency(salaryAmount ? salaryAmount : 0)
  }
];

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);

  if (value) {
    params.set("search", value)
  } else {
    params.delete("search");
  }

  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  if (params.get("date")) option["date"] = params.get("date");
  if (params.get("payrollPeriod")) option["period"] = params.get("payrollPeriod");
  if (params.get("search")) option["search"] = params.get("search");

  if (Object.keys(option).length === 0) {
    return new Promise((resolve) => resolve([]));
  } else {
    return getPayrollForBank(option);
  }
};

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);
  if (!params.get("date")) params.set("date", moment().format("YYYY-MM"));
  if (!params.get("payrollPeriod")) params.set("payrollPeriod", "first_payment");
  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.get("payrollPeriod")) option["period"] = params.get("payrollPeriod");
    if (params.has("search")) option["search"] = params.get("search");

    option["isExport"] = true;

    getPayrollForBank(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Successfully exported payroll for bank!"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}

export default withDataTable({
  title: "Payroll Report",
  subTitle: "Payroll For Bank",
  backLink: "/reports/payroll",
  showDate: true,
  showExport: true,
  allowClearPayroll: false,
  showPayrollPeriod: true,
  dateFormat: "MM/YYYY",
  datePlaceholder: t("text_mm_yyyy"),
  pathName,
  buttonOption: ExportFormLoader,
  pickerDate: "month",
  customEmptyMessage: t("text_please_select_date_and_employee"),
  columns,
  componentWillMount,
  handleSearch,
  getData,
});
